module.exports = __webpack_public_path__ + "static/img/IT.e1e06fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/IT.png
// module id = kmv6
// module chunks = 2